import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
  submitted: false,
};
export const Contact = (props) => {
  const [{ name, email, message, submitted }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  // const clearState = () => setState({ ...initialState,  });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setState({submitted: true});
    console.log(e.target)
    
    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }
    
    emailjs
      .sendForm("service_so280st", "template_ms5ic4d", e.target, "j4vcUfkS2b2CeEQFc")
      .then(
        (result) => {
          console.log(result.text);
          // clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{props.data ? props.data.title : "Loading..."}</h2>
                <p>
                {props.data ? props.data.subtitle : "Loading..."}
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                {!submitted &&<button type="submit" className="btn btn-custom btn-lg" disabled={submitted}>
                {props.data ? props.data.send : "Loading..."}
                </button> }
                {submitted && <button type="submit" className="btn btn-custom btn-lg" disabled={submitted}>
                  {props.data ? props.data.sent : "Loading..."}
                </button>}
                
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{props.data ? props.data.contact_label : "Loading..."}</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> {props.data ? props.data.address_label : "Loading..."}
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> {props.data ? props.data.phone_label : "Loading..."}
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            {/* <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> {props.data ? props.data.email_label : "Loading..."}
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div> */}
          </div>
          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {props.data ? props.data.watermark : "Loading..."}{" "}
            
          </p>
        </div>
      </div>
    </div>
  );
};
